<script>
  let expandedAnswer = '';

  function toggle(id) {
    expandedAnswer = expandedAnswer === id ? '' : id;
  }
</script>

<style lang="scss">
  .triangle_up {
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 25px solid #F5F5F5;
    margin-left: auto;
    margin-right: 25%;
    opacity: 0;
    transition: all ease 0.66s;
  }

  .triangle_up.visible {
    opacity: 1;
  }


  .faq_details {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2em;
    > p {
      font-size: 1.4em;
    }

    @media only screen and (max-width: 1900px) {
      margin-top: -4em;
    }

    @media only screen and (max-width: 1700px) {
      margin-top: -8em;
    }

    .faq_details__network {
      width: 100%;

      .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #F5F5F5;
        box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.160784);
        font-family: 'Open Sans', 'Montserrat', sans-serif;
        max-height: 0px;
        overflow-y: hidden;
        opacity: 0;
        transition: all ease 0.66s;

        h4 {
          text-transform: none;
          text-align: center;
          font-size: 2em;
          font-weight: 600;
          margin: 1em 0;
        }

        p {
          text-align: center;
          font-size: 1.2em;
        }

        ul {
          list-style-type: none;

          li {
            color: var(--font-color-alternative-2);
            font-size: 1.15em;

            strong {
              color: var(--font-color-alternative);
            }
          }
        }

        .network__grid {
          display: flex;
          justify-content: center;
        }

        .network__actions {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 100%;
          margin-top: 4em;

          a {
            display: flex;
            justify-content: center;
            text-decoration: none;
          }
        }
      }
    }

    .faq_details__network.expanded .content {
      padding: 0.5em 0;
      max-height: 1500px;
      height: auto;
      opacity: 1;
    }

    .faq_details__wrapper {
      display: flex;

      .faq_details__section {
        width: 35em;

        h4 {
          text-transform: none;
          text-align: center;
          font-size: 2em;
          font-weight: 600;
          margin: 1em 0;
        }

        nav {
          width: 100%;
          display: flex;
          justify-content: center;
          margin: 3em 0;

          .network_button {
            margin-left: 1em;

            img {
              margin-left: 0.5em;
            }
          }
        }

        .faq_details__questions {
          list-style: none;
          background-color: #F8F6F6;
          border-radius: 8px;
          box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.160784);
          padding: 2em;
          min-height: 22em;
          max-height: 30em;

          overflow-y: scroll;
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none;  /* Internet Explorer 10+ */

          * {
            box-sizing: border-box;
            padding: 0;
            margin: 0;
          }

          .faq_details__question {
            .question {
              font-size: 1.15em;
              font-weight: 500;
              padding: 0.5em 0;
              cursor: pointer;
              user-select: none;
            }

            .faq_details__answer {
              max-height: 0px;
              overflow-y: hidden;
              opacity: 0;
              transition: all ease-in-out 0.266s;

              p {
                font-size: 1.15em;
                padding-left: 1em;
              }

              ul {
                list-style: disc;
              }

              ul, ol {
                padding-left: 3em;

                li {
                  font-size: 1.15em;
                  padding: 0.5em 0;

                  li {
                    font-size: 1em;
                  }
                }
              }
            }

            .faq_details__answer.expanded {
              padding: 0.5em 0;
              max-height: 1500px;
              height: auto;
              opacity: 1;
            }
          }
        }

        .faq_details__questions::-webkit-scrollbar { /* WebKit */
          width: 0;
          height: 0;
        }
      }

      .faq_details__section:first-child {
        margin-right: 2em;
      }
    }
  }

  .faq_details__footer {
    h4 {
      text-transform: none;
      text-align: center;
      font-size: 2em;
      font-weight: 600;
      margin: 1em 0;
    }

    p {
      font-size: 1.15em;
      padding-left: 1em;
    }

    nav {
      width: 100%;
      margin-top: 2em;
      display: flex;
      justify-content: center;
    }
  }
</style>


<section class="faq_details">
  <p><strong>You can find the answers to the most common FAQs below.<br/>For anything else, please go to <a class="golden" href="https://www.voltaware.com/support" target="_blank">voltaware/support</a>.</strong></p>
  <section class="faq_details__wrapper">
    <section class="faq_details__section">
      <h4 id="order">Placing an order</h4>
      <ul class="faq_details__questions">
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-order-1')}>How can I order a Voltaware Sensor?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-order-1'}>
            <p>You can only order a Voltaware 1-Phase sensor on this website. Go to <a class="golden" href="https://octopus.voltaware.com/purchase" target="_blank">https://octopus.voltaware.com/purchase</a> to get Voltaware.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-order-2')}>Do I need an email address to order?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-order-2'}>
            <p>Yes, your Octopus email address is required to place the order and receive the tracking information once your order has been confirmed.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-order-3')}>Do I have to be an Octopus customer to order Voltaware?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-order-3'}>
            <p>Yes, Voltaware is available through our trusted network of utilities; you can only benefit from this discounted offer if you are an Octopus customer.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-order-4')}>I’ve ordered online, how can I check that
            my order has gone through?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-order-4'}>
            <p>Once your online order has been placed successfully, a confirmation message will be displayed on your screen and you will receive a payment confirmation email at the address provided during payment.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-order-5')}>How do I know if my order has been delayed?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-order-5'}>
            <p>If you have placed your order online, you should receive a confirmation email that includes the delivery date and a tracking number. If there is any delay beyond the date quoted in the confirmation email, please contact us at <a class="golden" href="mailto:octopus@voltaware.com" target="_blank">octopus@voltaware.com</a>.</p>
          </div>
        </li>
      </ul>
    </section>
    <section class="faq_details__section">
      <h4 id="payment">Payment</h4>
      <ul class="faq_details__questions">
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-payment-1')}>Is the payment portal secure?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-payment-1'}>
            <p>At Voltaware, we take your safety and security very seriously. Our website meets all the highest industry standards, and it's designed to keep your data private and protected at all times through the use of <a class="golden" href="https://www.mcafeesecure.com/for-websites" target="_blank">McAfee Secure</a>.</p>
            <p>When you are in the checkout, any information you enter is encoded to prevent anybody else from accessing your payment details.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-payment-2')}>Which cards do you accept?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-payment-2'}>
            <p>We accept all the major credit and debit cards that are able to perform payments in British Pounds (GBP). If you are using a suitable card and the payment is still not going through, please contact <a class="golden" href="mailto:octopus@voltaware.com" target="_blank">octopus@voltaware.com</a>.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-payment-3')}>Why is my payment not accepted?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-payment-3'}>
            <p>Please ensure that your name and billing address are entered exactly as they appear on your debit or credit card statements. If you are still experiencing any problems, please email us at <a class="golden" href="mailto:octopus@voltaware.com" target="_blank">octopus@voltaware.com</a>.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-payment-4')}>I am unable to pay for the order on the platform, can I
            order it directly from Voltaware?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-payment-4'}>
            <p>No, you are not currently able to place orders directly from Voltaware. Please reach out to us if you have any technical difficulties during the payment process by sending an email to <a class="golden" href="mailto:octopus@voltaware.com" target="_blank">octopus@voltaware.com</a>.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-payment-5')}>Does Voltaware charge a subscription fee? Will it charge at some point?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-payment-5'}>
            <p>There is no subscription fee charged for Octopus users. Octopus users will have unlimited access to the Voltaware app.</p>
          </div>
        </li>
      </ul>
    </section>
  </section>
  <section class="faq_details__wrapper">
    <section class="faq_details__section">
      <h4 id="delivery">Delivery</h4>
      <ul class="faq_details__questions">
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-delivery-1')}>How and when will my Voltaware sensor be shipped?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-delivery-1'}>
            <p>The Voltaware sensor will be shipped through Royal Mail within 2 business days after your order has been confirmed.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-delivery-2')}>How can I track my order?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-delivery-2'}>
            <p>You will receive an email with tracking details once the order has been shipped.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-delivery-3')}>I have not received any tracking information.
            How can I check the shipping status of my order?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-delivery-3'}>
            <p>If you have not received an email confirming the shipping of your order within two business days after you have successfully placed your order, please contact us at <a class="golden" href="mailto:octopus@voltaware.com" target="_blank">octopus@voltaware.com</a>.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-delivery-4')}>How can I cancel my order?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-delivery-4'}>
            <p>If the order has been already paid for, it can only be cancelled by requesting a refund, and shipping the sensor back to us if it has already been shipped. Please contact <a class="golden" href="mailto:octopus@voltaware.com" target="_blank">octopus@voltaware.com</a> for more information or consult our Refund Policy below.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-delivery-5')}>What should I do if my sensor is damaged?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-delivery-5'}>
            <p>You should email <a class="golden" href="mailto:octopus@voltaware.com" target="_blank">octopus@voltaware.com</a> with pictures of the damaged sensor and our support team will check the status of your sensor and advise further on getting a replacement. However, if the sensor has not been installed by a certified electrician and has been damaged during the installation, your warranty will be invalidated. Please refer to our terms and conditions for more information <a class="golden" href="https://voltaware.com/consumer-standard-terms" target="_blank">https://voltaware.com/consumer-standard-terms</a>.</p>
          </div>
        </li>
      </ul>
    </section>
    <section class="faq_details__section">
      <h4 id="installation">Installation</h4>
      <ul class="faq_details__questions">
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-installation-1')}>Can I install the Voltaware sensor myself?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-installation-1'}>
            <p>Although installation of the sensor may seem straightforward (see <a class="golden" href="https://voltaware.com/support/materials" target="_blank">https://voltaware.com/support/materials</a>), please ensure that it is installed by a qualified electrician. If you choose to install the sensor yourself, you will be doing this entirely at your own risk.</p>
            <p>Please see our standard term <a class="golden" href="https://voltaware.com/consumer-standard-terms" target="_blank">https://voltaware.com/consumer-standard-terms</a> for more details.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-installation-2')}>Does Voltaware work with installers?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-installation-2'}>
            <p>Voltaware has a list of recommended installers depending on your UK region. You will receive a list of suggested installers after your order has been confirmed. This list is updated regularly and is provided only to customers who have completed a purchase from Voltaware. Please check <a class="golden" href="/support#partners" target="_blank">Support &gt; Recommended installer</a> for more information.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-installation-3')}>Does Voltaware cover installation fees?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-installation-3'}>
            <p>No, Voltaware does not cover installation fees.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-installation-4')}>What happens if my Voltaware sensor fails during installation?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-installation-4'}>
            <p>If you have installed the sensor yourself and it fails during the installation, the 1 year warranty will be invalidated. If the sensor has been installed by a certified electrician and has failed during the installation, you need to email us at <a class="golden" href="mailto:octopus@voltaware.com" target="_blank">octopus@voltaware.com</a> with clear pictures of the sensor explaining what happened. Our support team will review the pictures and get back to you as soon as possible.</p>
            <p>If the issue has been caused by a Voltaware system fault and your warranty still applies, Voltaware will send you a replacement sensor. Please see our Return policy for now more information.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-installation-5')}>Which are the technical support working hours?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-installation-5'}>
            <p>Voltaware business hours are Monday-Friday 9a.m. to 5p.m. Greenwich Mean Time (GMT).</p>
          </div>
        </li>
      </ul>
    </section>
  </section>
  <section class="faq_details__wrapper">
    <section class="faq_details__section">
      <h4 id="application">Application</h4>
      <ul class="faq_details__questions">
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-application-1')}>How does Voltaware use my data?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-application-1'}>
            <p>Voltaware uses the electricity data measured by the sensors to improve the accuracy of the disaggregated electricity data it provides you, and to provide occasional alerts and recommendations regarding your energy use.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-application-2')}>Will Voltaware work outside of the UK?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-application-2'}>
            <p>The sensor and the Voltaware App work from anywhere in the world as long as you have an internet connection and the sensor is connected to it. However, the Octopus Smart Energy integration will only work in the UK.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-application-3')}>Can I still use Voltaware if I am no longer with Octopus Energy?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-application-3'}>
            <p>You can keep using it but you won’t have access to the Octopus Smart Energy Platform.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-application-4')}>What happens when I move home?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-application-4'}>
            <p>You will have to uninstall the sensor and reinstall it in your new home. If you are unsure on how to do this, please send us an email at <a class="golden" href="mailto:octopus@voltaware.com" target="_blank">octopus@voltaware.com</a>.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-application-5')}>Can I delete my Voltaware App account?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-application-5'}>
            <p>You can request to delete your account by sending an email to <a class="golden" href="mailto:octopus@voltaware.com" target="_blank">octopus@voltaware.com</a>.</p>
          </div>
        </li>
      </ul>
    </section>
    <section class="faq_details__section">
      <h4 id="refund">Refund & Return Policy</h4>
      <ul class="faq_details__questions">
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-refund-1')}>What is the Voltaware return policy? How can I return
            the sensor?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-refund-1'}>
            <p>Although we hope that you will never need to, you have the right to cancel at any time from the moment you place your order, and up to 14 days from the day you receive your Voltaware sensor.</p>
            <p>You need to notify Voltaware of your wish to cancel your order within this time period by emailing <a class="golden" href="mailto:octopus@voltaware.com" target="_blank">octopus@voltaware.com</a>. You then have a further 14 days from the date you notify Voltaware of your cancellation to return the Voltaware sensor.</p>
            <p>To request a refund, please send your request to octopus@voltaware.com within 14 days after you have received your sensor, including your dispatch notification, your invoice and details and pictures of your sensor.</p>
            <p>The return request is not eligible in the following scenarios:</p>
            <ul>
              <li>Any damage to the box or to the sensor</li>
              <li>The sensor is not in its original condition</li>
              <li>The sensor is returned without its original package and items included with the sensor at the time of delivery.</li>
              <li>The warranty period is invalidated</li>
            </ul>
            <p>If your return meets the conditions above, please send your sensor in its original package exactly as you found it at the time of delivery.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-refund-2')}>How long is the Warranty?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-refund-2'}>
            <p>If you discover a defect in the materials used to make the equipment or how it is put together (its workmanship) within one (1) year from the date when you receive the equipment from us, we will either:</p>
            <ol type="a">
              <li>repair or replace any defective equipment or its component with new or refurbished components of the same or (if the original equipment or components are not available) greater functionality; or</li>
              <li>accept the return of the equipment and refund the money that the person who bought the equipment paid for the equipment by its original purchaser.</li>
            </ol>
            <p>We will choose which of option (a) or option (b) above will be provided to you and make sure that you get either replacement equipment or a refund within 45 days of us receiving the equipment that you think is defective.</p>
            <p>In order to make use of the Equipment Warranty you must:</p>
            <ol type="a">
              <li>notify us of the intention to claim by visiting support@voltaware.com during the period while the Equipment Warranty is still valid and provide a description of the failure; and</li>
              <li>comply with our return shipping instructions.</li>
            </ol>
            <p>We will have no warranty obligations with respect to returned equipment if we determine, acting reasonably after examination of the returned equipment, that the equipment you return has any of the following features:</p>
            <ol type="a">
              <li>it is equipment marked as “Not for Sale”</li>
              <li>it has been subject to:
                <ol type="i">
                  <li>modifications, alterations, tampering, or improper maintenance or repairs;</li>
                  <li>handling, storage, installation, testing, or use not in accordance with our instructions;</li>
                  <li>abuse or misuse;</li>
                  <li>breakdowns, fluctuations, or interruptions in electric power; or</li>
                  <li>acts of God, including, but not limited to, lightning, flood, tornado, earthquake, or hurricane.</li>
                </ol>
              </li>
            </ol>
            <p>Please consult our full Terms & Conditions here <a class="golden" href="https://voltaware.com/consumer-standard-terms" target="_blank">https://voltaware.com/consumer-standard-terms</a></p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-refund-3')}>How can I get a replacement?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-refund-3'}>
            <p>A replacement can only be provided in case of a failure of the product, which is covered by the warranty at no extra cost to you. If the warranty period has elapsed, you will not be refunded and will have to buy a new sensor.</p>
          </div>
        </li>
        <li class="faq_details__question">
          <p class="question" on:click={() => toggle('question-refund-4')}>Do you refund original postage charges?</p>
          <div class="faq_details__answer" class:expanded={expandedAnswer === 'question-refund-4'}>
            <p>We comply with all Consumer Contract Regulations. Please find our cancellation policy at <a class="golden" href="https://voltaware.com/consumer-standard-terms" target="_blank">https://voltaware.com/consumer-standard-terms</a></p>
          </div>
        </li>
      </ul>
    </section>
  </section>
  <section class="faq_details__footer">
    <h4>More FAQs</h4>
    <p>If you have not found what you are looking for, please consult <a class="golden" href="https://voltaware.com/support" target="_blank">voltaware.com/support</a>.</p>
    <nav>
      <a href="https://voltaware.com/support/materials" target="_blank">
        <button class="ubuntu golden-inverted stretched">support materials</button>
      </a>
    </nav>
  </section>
</section>

